import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { Copy, FileJson, Info, ListCheck, Loader } from "lucide-react";
import {
  verifyPrefillv3Details,
  verifyUanDirectSrv3,
  verifyUanMobile,
  verifyUanNameDob,
} from "../../../Services/ApiTestService/apiTestService";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isNumeric } from "validator";

function UanDirectSrv3() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const [uan, setUan] = useState("");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);

  const [profileData, setProfileData] = useState(null);
  let apiResponse;

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  const isNumber = (value) => {
    if (!value) return false;

    return isNumeric(value, { no_symbols: true });
  };

  // ---------------- VERIFY UAN ----------------
  const handleVerifyConsumer = async () => {
    if (!profileData) return;

    if (!uan) {
      showErrorToast("Please enter UAN");
    }

    const validateUan = isNumber(uan);

    if (!validateUan) {
      showErrorToast("Please enter Number Only");
    }

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await verifyUanDirectSrv3({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        uan,
      });

      if (res) {
        apiResponse = res;
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={"UAN Direct Srv3"} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start pb-14">
        {/* ---------------- FORM ---------------- */}
        <div className="max-w-3xl mx-auto mt-8 bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="p-6 sm:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
              {/* Name*/}
              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">
                  UAN <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type="text"
                    required
                    maxLength={15}
                    value={uan}
                    onChange={(e) => setUan(e.target.value)}
                    className="w-full h-11 px-4 bg-gray-50 border border-gray-300 rounded-lg text-gray-900 text-sm transition-all focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none placeholder:text-gray-400"
                    placeholder="e.g. 101610621151"
                  />
                </div>
              </div>
            </div>

            {/* Error Message Section */}
            {inputError && (
              <div className="mt-4 p-3 rounded-lg bg-red-50 border border-red-100 flex items-center gap-2 text-red-700 text-sm animate-pulse">
                <span className="font-bold">⚠️ Error:</span> {inputError}
              </div>
            )}

            {/* Verify Action */}
            <div className="mt-8 flex items-center justify-between border-t border-gray-100 pt-6">
              <p className="text-xs text-gray-500 italic">
                Ensure details match your official documents.
              </p>
              <button
                disabled={isLoading || !uan}
                onClick={handleVerifyConsumer}
                className="relative inline-flex items-center justify-center px-8 py-2.5 font-semibold text-white transition-all duration-200 bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 disabled:opacity-40 disabled:cursor-not-allowed shadow-md shadow-blue-200"
              >
                {isLoading ? (
                  <span className="flex items-center gap-2">
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      />
                    </svg>
                    Verifying...
                  </span>
                ) : (
                  "Verify UAN"
                )}
              </button>
            </div>
          </div>
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.data?.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/*  Instruction Card */}
        <div className="mt-12 max-w-2xl mx-auto">
          <div className="relative overflow-hidden rounded-xl border border-indigo-100 bg-gradient-to-br from-white to-indigo-50/30 p-6 shadow-sm">
            {/* Decorative accent bar */}
            <div className="absolute left-0 top-0 h-full w-1 bg-indigo-500"></div>

            <div className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
                <Info size={20} />
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-1">
                  Important Instructions
                  <span className="text-red-500 text-xs" title="Required">
                    *
                  </span>
                </h3>

                <div className="mt-2 space-y-3 text-sm leading-relaxed text-gray-600">
                  <p>
                    Please enter a{" "}
                    <span className="font-medium text-gray-900">
                      valid UAN Number
                    </span>{" "}
                    and click the <span className="italic">Verify</span> button.
                  </p>
                  <p>
                    Once verified, the system will provide a structured response
                    containing the associated contact details. You can review or
                    copy this data for your records.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 w-full max-w-6xl">
            {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-8" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>

            {/* -------- USER DETAILS -------- */}
            <div className="bg-gray-200 p-5 rounded-md">
              <h2 className="text-2xl flex items-center justify-center gap-2 font-bold text-blue-500 mb-1">
                <ListCheck /> All Details
              </h2>
              <hr className="mb-8" />

              {/* BASIC INFO */}
              <div className="space-y-2 text-sm">
                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    Name:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.uan_details?.[response?.data?.uan?.[0]]
                      ?.basic_details?.name || "N/A"}
                  </span>
                </div>

                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    DOB:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.uan_details?.[response?.data?.uan?.[0]]
                      ?.basic_details?.date_of_birth || "N/A"}
                  </span>
                </div>

                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    Gender:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.uan_details?.[response?.data?.uan?.[0]]
                      ?.basic_details?.gender || "N/A"}
                  </span>
                </div>

                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    UAN:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.uan?.[0] || "N/A"}
                  </span>
                </div>

                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    Mobile:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.uan_details?.[response?.data?.uan?.[0]]
                      ?.basic_details?.mobile || "N/A"}
                  </span>
                </div>
              </div>

              {/* EMPLOYMENT DETAILS */}
              <div className="mt-8">
                <h3 className="font-bold text-xl text-gray-800 mb-4">
                  Employment Details
                </h3>

                <div className="border p-4 rounded-md bg-blue-500 text-white space-y-2">
                  <div>
                    <span className="font-semibold text-blue-200 w-40 inline-block">
                      Employer:
                    </span>
                    {response?.data?.summary?.recent_employer_data
                      ?.establishment_name || "N/A"}
                  </div>

                  <div>
                    <span className="font-semibold text-blue-200 w-40 inline-block">
                      Member ID:
                    </span>
                    {response?.data?.summary?.recent_employer_data?.member_id ||
                      "N/A"}
                  </div>

                  <div>
                    <span className="font-semibold text-blue-200 w-40 inline-block">
                      Establishment ID:
                    </span>
                    {response?.data?.summary?.recent_employer_data
                      ?.establishment_id || "N/A"}
                  </div>

                  <div>
                    <span className="font-semibold text-blue-200 w-40 inline-block">
                      DOJ:
                    </span>
                    {response?.data?.summary?.recent_employer_data
                      ?.date_of_joining || "N/A"}
                  </div>

                  <div>
                    <span className="font-semibold text-blue-200 w-40 inline-block">
                      Date of Exit:
                    </span>
                    {response?.data?.summary?.recent_employer_data
                      ?.date_of_exit || "N/A"}
                  </div>

                  <div>
                    <span className="font-semibold text-blue-200 w-40 inline-block">
                      Employment Status:
                    </span>
                    {response?.data?.summary?.is_employed
                      ? "Active"
                      : "Inactive"}
                  </div>
                </div>
              </div>

              {/* UAN SOURCE */}
              {response?.data?.uan_source?.length > 0 && (
                <div className="mt-8">
                  <h3 className="font-bold text-xl text-gray-800 mb-3">
                    UAN Source
                  </h3>

                  <div className="border p-4 rounded-md bg-blue-500 text-white">
                    {response.data.uan_source.map((item, i) => (
                      <div key={i}>
                        <span className="font-semibold text-blue-200 w-32 inline-block">
                          Source:
                        </span>
                        {item.source} ({item.uan})
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default UanDirectSrv3;
